import React, { Component } from 'react'

import { Upload, message, Form } from 'antd'
import { Icon } from '@ant-design/compatible';

import './Avatar.scss'
import ImageCropper from '../cropper/ImageCropper'
import {readerService} from "../../services/readerService";

function beforeUpload(file) {
  const notIsImage = file.type.indexOf("image") <= -1

  if (notIsImage) {
    message.error('Você só pode adicionar imagens!')
  }

  return notIsImage
}

class Avatar extends Component {
  state = {
    loading: false,
    cropping: false,
    image: '',
  }

  handleChange = (info) => {
    if (info.file.type.indexOf("image") <= -1) {
      this.setState({ loading: false })
      return
    }

    readerService().getBase64(info.file, imageUrl => {
      this.setState({
        image: imageUrl,
        loading: false,
        cropping: true
      })
    })
  }

  onRequest = event => new Promise((resolve) => this.setState({ loading: true }, () => {
    resolve(event)
  }))

  finishCrop = image => {
    this.props.onChange(image)

    this.setState({ cropping: false }, () => this.props.onFinishUpload(image))
  }

  handleCancel = () => this.setState({ loading: false, cropping: false, image: '' })

  render() {
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    )
    const { cropping, image } = this.state
    const { imageUrl, disabled } = this.props

    return (
      <React.Fragment>
        <Upload
          disabled={disabled}
          name="avatar"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          beforeUpload={beforeUpload}
          onChange={this.handleChange}
          customRequest={this.onRequest}
        >
          {imageUrl ? <img width={140} height={140} src={imageUrl} alt="avatar" /> : uploadButton}
          <input style={{ display: 'none' }} />
        </Upload>
        <ImageCropper handleCancel={this.handleCancel} cropRatio={1} image={image} isVisible={cropping} handleOk={this.finishCrop} />
      </React.Fragment>
    )
  }
}

function AvatarInput({ form, name, imageUrl = "", disabled, onFinishUpload }) {
  return (
    <Form.Item>
      {form.getFieldDecorator(name, { initialValue: imageUrl})(
        <Avatar form={form} name={name} imageUrl={imageUrl} disabled={disabled} onFinishUpload={onFinishUpload} />
      )}
    </Form.Item>
  )
}

export default AvatarInput
